import Repository from './Repository'
import { AxiosResponse } from 'axios'
import { Login } from '../models/login'
import { TokenModel } from '../models/token.model'
import {Register} from "@/models/register";
import PasswordModel from "@/models/password.model";
import {UserPermission} from "@/models/permission.model";
import {UserUpdate} from "@/models/userUpdate";
import {DichVuCreate} from "@/models/dichVuCreate";
import {LieuTrinhCreate} from "@/models/lieuTrinhCreate";
import {SanPhamCreate} from "@/models/sanPhamCreate";
import {KhachHangCreate} from "@/models/khachHangCreate";
import {HoaDonCreate} from "@/models/hoaDonCreate";
import {MuaLieuTrinhCreate} from "@/models/muaLieuTrinhCreate";
import {MuaDichVuCreate} from "@/models/muaDichVuCreate";
import {ThanhPhan} from "@/models/thanhPhan";
import {HoaDonDetail} from "@/models/hoaDonDetail";
import {DichVuUpdate} from "@/models/dichVuUpdate";
import {LieuTrinhUpdate} from "@/models/lieuTrinhUpdate";
import {SanPhamUpdate} from "@/models/sanPhamUpdate";
import {ThucHienLieuTrinhCreate} from "@/models/thucHienLieuTrinhCreate";
import {KhachHangUpdate} from "@/models/khachHangUpdate";
import {NhapHangHoaCreate} from "@/models/nhapHangHoaCreate";
import {NhapHangHoaUpdate} from "@/models/nhapHangHoaUpdate";
import {HoaDonUpdate} from "@/models/hoaDonUpdate";

const resource = '/auth'

export default new class {
  auth (login: Login): Promise<AxiosResponse<TokenModel>> {
    console.log('############################## loginpage auth api')
    return Repository.post<TokenModel>(`${resource}/login`, login)
  }
  updateUser(updateUser: UserUpdate): Promise<any>{
    return Repository.post<any>(`${resource}/updateUser`, updateUser);
  }
  userPermission(login: Login): Promise<AxiosResponse<UserPermission>>{
    return Repository.post<UserPermission>(`${resource}/getpermission`, login);
  }
  deleteUserById(id: number): Promise<any>{
    return Repository.delete<any>(`${resource}/deleteUser/${id}`);
  }
  registerUser(register: Register): Promise<any>{
    return Repository.post<any>(`${resource}/register`, register);
  }
  getUserById(id: number): Promise<any>{
    return Repository.get<any>(`${resource}/userById/${id}`);
  }
  getListUser(): Promise<any>{
    return Repository.get<any>(`${resource}/getListUser`);
  }
  createDichVu(dichVuCreate: DichVuCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createDichVu`, dichVuCreate);
  }
  updateHoaDon(hoaDonUpdate: HoaDonUpdate): Promise<any>{
    return Repository.post<any>(`${resource}/updateHoaDon`, hoaDonUpdate);
  }
  getListDichVu(): Promise<any>{
    return Repository.get<any>(`${resource}/getListDichVu`);
  }
  getListDichVuAll(): Promise<any>{
    return Repository.get<any>(`${resource}/getListDichVuAll`);
  }
  createLieuTrinh(lieuTrinhCreate: LieuTrinhCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createLieuTrinh`, lieuTrinhCreate);
  }
  getListLieuTrinh(): Promise<any>{
    return Repository.get<any>(`${resource}/getListLieuTrinh`);
  }
  getListLieuTrinhAll(): Promise<any>{
    return Repository.get<any>(`${resource}/getListLieuTrinhAll`);
  }
  createSanPham(sanPhamCreate: SanPhamCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createSanPham`, sanPhamCreate);
  }
  createHoaDon(hoaDonCreate: HoaDonCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createHoaDon`, hoaDonCreate);
  }
  getListSanPham(): Promise<any>{
    return Repository.get<any>(`${resource}/getListSanPham`);
  }
  getListSanPhamAll(): Promise<any>{
    return Repository.get<any>(`${resource}/getListSanPhamAll`);
  }
  createKhachHang(khachHangCreate: KhachHangCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createKhachHang`, khachHangCreate);
  }
  updateKhachHang(khachHangUpdate: KhachHangUpdate): Promise<any>{
    return Repository.post<any>(`${resource}/updateKhachHang`, khachHangUpdate);
  }
  getListKhachHang(): Promise<any>{
    return Repository.get<any>(`${resource}/getListKhachHang`);
  }
  createMuaLieuTrinh(muaLieuTrinhCreate: MuaLieuTrinhCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createMuaLieuTrinh`, muaLieuTrinhCreate);
  }
  createMuaDichVu(muaDichVuCreate: MuaDichVuCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createMuaDichVu`, muaDichVuCreate);
  }
  createThanhPhan(thanhPhans: ThanhPhan[]): Promise<any>{
    return Repository.post<any>(`${resource}/createThanhPhan`, thanhPhans);
  }
  getListHoaDon(timeFrom: number, timeTo: number, idKhachHang: number): Promise<any>{
    return Repository.get<any>(`${resource}/getListHoaDon/${timeFrom}/${timeTo}/${idKhachHang}`);
  }
  getDoanhThu(hoaDonDetails: HoaDonDetail[]): Promise<any>{
    return Repository.post<any>(`${resource}/getDoanhThu`, hoaDonDetails);
  }
  updateDichVu(dichVuUpdate: DichVuUpdate): Promise<any>{
    return Repository.post<any>(`${resource}/updateDichVu`, dichVuUpdate);
  }
  updateLieuTrinh(lieuTrinhUpdate: LieuTrinhUpdate): Promise<any>{
    return Repository.post<any>(`${resource}/updateLieuTrinh`, lieuTrinhUpdate);
  }
  updateSanPham(sanPhamUpdate: SanPhamUpdate): Promise<any>{
    return Repository.post<any>(`${resource}/updateSanPham`, sanPhamUpdate);
  }
  createThucHienLieuTrinh(thucHienLieuTrinhCreate: ThucHienLieuTrinhCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createThucHienLieuTrinh`, thucHienLieuTrinhCreate);
  }
  getListLichSuLieuTrinh(timeFrom: number, timeTo: number, idKhachHang: number): Promise<any>{
    return Repository.get<any>(`${resource}/getListLichSuLieuTrinh/${timeFrom}/${timeTo}/${idKhachHang}`);
  }
  getNotification(): Promise<any>{
    return Repository.get<any>(`${resource}/getNotification`);
  }
  checkThanhPhan(thanhPhans: ThanhPhan[]): Promise<any>{
    return Repository.post<any>(`${resource}/checkThanhPhan`, thanhPhans);
  }
  getListHoaDonAll(timeFrom: number, timeTo: number): Promise<any>{
    return Repository.get<any>(`${resource}/getListHoaDonAll/${timeFrom}/${timeTo}`);
  }
  createNhapHangHoa(nhapHangHoaCreate: NhapHangHoaCreate): Promise<any>{
    return Repository.post<any>(`${resource}/createNhapHangHoa`, nhapHangHoaCreate);
  }
  updateNhapHangHoa(nhapHangHoaUpdate: NhapHangHoaUpdate): Promise<any>{
    return Repository.post<any>(`${resource}/updateNhapHangHoa`, nhapHangHoaUpdate);
  }
  deleteNhapHangHoa(id: number): Promise<any>{
    return Repository.delete<any>(`${resource}/deleteNhapHangHoa/${id}`);
  }
  getListNhapHangHoa(timeFrom: number, timeTo: number): Promise<any>{
    return Repository.get<any>(`${resource}/getListNhapHangHoa/${timeFrom}/${timeTo}`);
  }
  getDebt(khachHangId: number): Promise<any>{
    return Repository.get<any>(`${resource}/getDebt/${khachHangId}`);
  }
  getListHoaDonByKhachHang(khachHangId: number): Promise<any>{
    return Repository.get<any>(`${resource}/getListHoaDonByKhachHang/${khachHangId}`);
  }
  getListThanhPhan(hoaDonId: number): Promise<any>{
    return Repository.get<any>(`${resource}/getListThanhPhan/${hoaDonId}`);
  }
}
